import React from 'react';
import { IconProps } from './types';
import cx from 'classnames';
import styles from './SocialIcons.module.scss';

export const YouTube = ({ ...svgProps }: IconProps) => (
  <svg
    {...svgProps}
    className={cx(styles.base, svgProps.className)}
    width="40"
    height="28"
    viewBox="0 0 40 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path d="M38.2354 2.4036C36.7993 0.696387 34.1477 0 29.0838 0H10.702C5.5222 0 2.82572 0.741308 1.39496 2.5589C0 4.33105 0 6.94218 0 10.5561V17.4441C0 24.4453 1.65511 28 10.702 28H29.084C33.4753 28 35.9087 27.3855 37.483 25.8789C39.0974 24.3339 39.7862 21.8113 39.7862 17.4441V10.5561C39.7862 6.74492 39.6783 4.11839 38.2354 2.4036ZM25.5429 14.951L17.1957 19.3135C17.0091 19.4111 16.8051 19.4594 16.6012 19.4594C16.3705 19.4594 16.1402 19.3973 15.9363 19.2739C15.5523 19.0412 15.3178 18.625 15.3178 18.176V9.479C15.3178 9.03083 15.5517 8.615 15.9349 8.38219C16.3183 8.14937 16.795 8.13346 17.1928 8.34009L25.5399 12.6745C25.9646 12.895 26.2313 13.3334 26.2319 13.8117C26.2325 14.2904 25.9669 14.7295 25.5429 14.951Z" />
  </svg>
);
